import PermintaanAsetApi from './PenerimaanAsetApi';

export default PermintaanAsetApi;
